import { GKButton, Grid2, Switch, Typography } from "components";
import { CompanySettingApi } from "interfaces/Settings";
import { Controller, useForm } from "react-hook-form";
import { useUpdateCompanySettingsMutation } from "store/features/CompanySetting";
import { useAppSelector } from "store/store";
import useDocumentTitle from "utils/useDocumentTitle";

interface Props {
  data: CompanySettingApi;
  companyId: string;
}

const LedgerSettings = (props: Props) => {
  useDocumentTitle("Ledger");

  const { data, companyId } = props;

  const userData = useAppSelector((state) => state?.user?.userData);

  const [updateCompanySettings, { isLoading }] =
    useUpdateCompanySettingsMutation();

  const form = useForm({
    defaultValues: {
      deductTaxFromDividend: false,
    },
    values: {
      deductTaxFromDividend: data?.deductTaxFromDividend,
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit((values) =>
        updateCompanySettings({
          id: companyId,
          body: values,
        }),
      )}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
          <Controller
            name="deductTaxFromDividend"
            control={form.control}
            render={({ field }) => (
              <Switch
                {...field}
                disabled={!userData?.broker?.addDividendToLedger}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />
          <Typography fontSize={16}>
            Account for TDS in dividend accrual
          </Typography>
        </Grid2>
        <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
          <GKButton variant="contained" type="submit" loading={isLoading}>
            Save
          </GKButton>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default LedgerSettings;
